import { csvParse } from "../scripts/utilities";

export const movieModel = {
    ratings: [[], [], [], [], [], [], [], [], [], []],

    addMovie(imdbid, tmdbid, rating, title, originalTitle, imgurl, type, imdbRating, releaseDate) {
        const movie = {
            imdbid: imdbid,
            tmdbid: tmdbid,
            rating: rating,
            title: title,
            type: type,
            originalTitle: originalTitle,
            imgurl: imgurl,
            type: type,
            imdbRating, imdbRating,
            releaseDate: releaseDate
        }
        this.ratings[rating - 1] = [...this.ratings[rating - 1], movie];
    },

    changeRating(imdbid, newRating) {
        for (let r = 0; r < 10; r++) {
            for (let i = 0; i < this.ratings[r].length; i++) {
                if (this.ratings[r][i].imdb == imdb) {
                    this.ratings[r][i].rating = newRating;
                    return;
                }
            }
        }
        console.error("Movie with ID '" + imdbid + "' not found!");
    },

    initRatingsArrayFromCSVArray(csvArray) {
        console.log("Initializing ratings array...");
        if (this.ratings == undefined) {
            this.ratings = [[], [], [], [], [], [], [], [], [], []];
        }
        for (let i = 0; i < 10; i++) {
            if (this.ratings[i] == undefined) {
                this.ratings[i] = [];
            }
        }
        for (let i = 0; i < csvArray.length; i++) {
            //GET INFO FROM PERSISTANT STORAGE FIRST!!!
            //THEN, IF NO INFO WAS FOUND: USE API TO GET tmdbid AND IMGURL (using getMovieByID!)
            const tmdbid = null;
            const imgurl = null;
            this.addMovie(csvArray[i].Const, tmdbid, csvArray[i]["Your Rating"], csvArray[i].Title, csvArray[i]["Original Title"], imgurl, csvArray[i]["Title Type"], csvArray[i]["IMDb Rating"], csvArray[i]["Release Date"]);
        }
    },

    parseCSVFile(file) {
        console.log("Parsing csv file...");
        return csvParse(file).then(data => this.initRatingsArrayFromCSVArray(data));
    }
}